import { AxiosResponse } from 'axios';
import jwt from 'jwt-decode';
import { OidcClient, UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { NavigateFunction } from 'react-router-dom';
import http from 'utilities/http-common';
import i18next from "i18next";

export interface User {
    email: string;
    name: string; // RRN
    surname: string; // Last Name
    given_name: string; // First Name
    role: string[];
    loginProvider: string;
    nbf: number;
    exp: number;
    iat: number;
    tenantId: string;
}

export function getRoles(user: User): string[] {
    return user.role;
}

// export function login(redirectUri: string = '/'): void {
//     window.open(
//         `${process.env.REACT_APP_API_URL}/digipolis/login?redirectUri=${redirectUri}`,
//         '_self'
//     );
// }

const config: UserManagerSettings = {
    // the URL of our identity server
    authority: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : '',
    // this ID maps to the client ID in the identity client configuration
    client_id: "Veiligheidsverificaties_App",
    // URL to redirect to after login
    // redirect_uri: "http://localhost:3000/login",
    redirect_uri: `${document.location.origin}/login`,
    response_type: "code",
    // the scopes or resources we would like access to
    scope: "openid offline_access Veiligheidsverificaties",
    // URL to redirect to after logout
    // post_logout_redirect_uri: "https://localhost:3000/login",
    post_logout_redirect_uri: `${document.location.origin}/login`,
    stateStore: new WebStorageStateStore({ store: window.localStorage }),
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    filterProtocolClaims: false,
};

// initialise!
const userManager = new UserManager(config)


export async function loginBpolb(redirectUri: string = '/', isLocal: boolean = false): Promise<void> {
    await userManager.signinRedirect({ extraQueryParams: { external: isLocal.toString(), culture: i18next.language } });
    userManager.events.addAccessTokenExpiring(() => {
        console.log('token expired');
        userManager.signinSilent({ extraQueryParams: { external: false } });
    });

    // userManager.startSilentRenew();
    // userManager.signinRedirectCallback().then((user) => {
    //     localStorage.setItem('user', JSON.stringify(user.profile));
    //     localStorage.setItem('token', user.access_token);
    // });
    // redirectUri = 'https://localhost:3000'
    // window.open(
    // 	`https://localhost:44374/account/login?ReturnUrl=${redirectUri}&response_type=code&client_id=Veiligheidsverificaties_App&scope=openid`,
    // 	'_self'
    // );

    // window.open(
    // 	`${process.env.REACT_APP_API_URL}/account/login?redirectUri=${redirectUri}`,
    // 	'_self'
    // );
}

export async function checkAuthUser(redirectUri: string = '/'): Promise<User> {
    return userManager.signinRedirectCallback().then(async (user) => {
        localStorage.setItem('token', user?.access_token as string);
        const test = convertUser(user);
        localStorage.setItem('user', JSON.stringify(test));
        user.profile.exp = test.exp;
        await userManager.storeUser(user);
        return test;
    }).catch((e) => {
        console.log('failed', e);
        return {} as User;
    });
}

export function getUserAsync(): Promise<User> {
    const user = userManager.getUser().then((user) => {
        const test = convertUser(user);
        console.log('getUserAsync', test)
        return test;
    })
        .catch((e) => { console.log('failed', e); return {} as User; });
    return user;
}

export function getUser() {
    // const tokenData = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    // console.log('getUser', tokenData, userData)
    // if (tokenData && userData) {
    //     const user = JSON.parse(userData) as any;
    //     const token = jwt<any>(tokenData);
    //     // console.log(user, token)
    //     const test: User = {
    //         name: user.name,
    //         surname: user.family_name,
    //         given_name: user.given_name,
    //         role: typeof token.role === 'string' ? [token.role] : token.role,
    //         loginProvider: '',
    //         nbf: token.nbf,
    //         exp: token.exp,
    //         iat: token.iat
    //     }
    //     return test;
    // }
    if (userData) {
        return JSON.parse(userData) as User;
    }
    return {} as User;
}

export function updateUser(user: User): void {
    localStorage.setItem('user', JSON.stringify(user));
}

export function logout(redirectUri: string = '/login'): void {
    console.log('logout called');
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    userManager.signoutRedirect({ post_logout_redirect_uri: redirectUri, extraQueryParams: { redirectUri: redirectUri } });
    // navigate(redirectUri);
    // window.open(
    //     `${process.env.REACT_APP_API_URL}/account/logout?redirectUri=${redirectUri}`,
    //     '_self'
    // );
}

export async function updateToken(): Promise<any> {
    const data = (await userManager.signinSilent());
    userManager.signinSilentCallback();
    http.defaults.baseURL = 'https://localhost:44374'
    return await http.get('/connect/token').then((resp) => {
        localStorage.setItem('token', resp.data);
        localStorage.setItem('user', JSON.stringify(jwt(resp.data)));
        http.defaults.baseURL = 'https://localhost:44375'
        return resp.data;
    });
}

export function isAuthenticated(user: User): boolean {
    if (user) {
        return !isTokenExpired(user);
    }
    return false;
}

export function isTokenExpired(user: User): boolean {
    const now = Date.now() / 1000;
    if (now < user.exp) return false;

    // localStorage.removeItem('user');
    // localStorage.removeItem('token');
    return true;
}

export function checkAuth(requiredRoles: string[], user: User | null, inAllRoles: boolean = true, onlyRoles: boolean = false): boolean {
    if (user === null) return false;
    if (!isAuthenticated(user)) return false;
    if (!user.role) {
        return false;
    }
    const roles = getRoles(user);

    if (onlyRoles) {
        if (requiredRoles.length == roles.length && requiredRoles.every(r => roles.some(s => s === r))) {
            return true;
        }
        return false;
    }

    if (inAllRoles) {
        if (requiredRoles.every(r => roles.some(s => s === r))) {
            return true;
        }
    }
    else {
        if (requiredRoles.some((item) => roles.includes(item))) {
            return true;
        }
    }


    return false;
}

function convertUser(user: any): User {
    const profile = user?.profile;
    const access_token = jwt<any>(user?.access_token as string);
    const test: User = {
        email: profile?.unique_name,
        name: profile?.given_name,
        surname: profile?.family_name as string,
        given_name: profile?.given_name as string,
        role: access_token.role ? typeof access_token.role === 'string' ? [access_token.role] : access_token.role : [],
        loginProvider: '',
        nbf: profile?.nbf,
        exp: access_token?.exp as number,
        iat: profile?.iat as number,
        tenantId: access_token?.tenantId as string
    }
    return test;
}
